import {
  LayoutDashboard,
  Zap,
  FileText,
  ClipboardList,
  Settings,
  Factory,
  Languages,
  Image,
  Users,
  Palette,
  Monitor,
  ExternalLink,
  Cpu,
  PlusCircle,
  KeyRound,
  CreditCard,
  AlertTriangle,
  Workflow,
  LucideIcon,
} from 'lucide-react';

export interface AdminNavItem {
  path: string;
  title: string;
  description: string;
  icon: LucideIcon;
}

export interface AdminNavCategory {
  title: string;
  items: AdminNavItem[];
}

export const ADMIN_NAV_CATEGORIES: AdminNavCategory[] = [
  {
    title: 'Admin & Configuration',
    items: [
      {
        path: '/machine-setup/settings',
        title: 'Machine Type Settings',
        description: 'Configure static attributes applied per machine type during creation',
        icon: Cpu,
      },
      {
        path: '/ocpi-admin',
        title: 'OCPI Settings',
        description: 'Manage OCPI connections and service status',
        icon: Settings,
      },
      {
        path: '/manufacturers',
        title: 'Manufacturers',
        description: 'Manage EV charger manufacturers',
        icon: Factory,
      },
      {
        path: '/communities',
        title: 'Communities',
        description: 'Manage community pricing profiles',
        icon: Users,
      },
      {
        path: '/translations',
        title: 'Translations',
        description: 'Manage translations for applications',
        icon: Languages,
      },
      {
        path: '/assets',
        title: 'Asset Management',
        description: 'Manage icons, images, videos, and Lottie animations',
        icon: Image,
      },
      {
        path: '/api-tokens',
        title: 'API Tokens',
        description: 'Create and manage external API tokens with scoped access',
        icon: KeyRound,
      },
      {
        path: '/billing',
        title: 'Billing Configuration',
        description: 'Operator billing config, excluded machines, and reimbursement fees',
        icon: CreditCard,
      },
    ],
  },
  {
    title: 'Main Features',
    items: [
      {
        path: '/dashboard',
        title: 'Operator Dashboard',
        description: 'Fleet status, analytics, sessions, and alerts',
        icon: LayoutDashboard,
      },
      {
        path: '/energy-management',
        title: 'Energy Management',
        description: 'Site hierarchy and energy usage statistics',
        icon: Zap,
      },
      {
        path: '/kiosk-reports',
        title: 'Kiosk Reports',
        description: 'Kiosk session reports with date filters',
        icon: FileText,
      },
      {
        path: '/sessions-report',
        title: 'Sessions Report',
        description: 'Advanced session reports with meter values',
        icon: ClipboardList,
      },
      {
        path: '/data-error',
        title: 'Data Error Report',
        description: 'Irregular delta readings — investigate and resolve anomalous meter values',
        icon: AlertTriangle,
      },
      {
        path: '/machine-setup',
        title: 'Machine Setup',
        description: 'Create and validate EV charging machines',
        icon: PlusCircle,
      },
      {
        path: '/operator/2002123712/assignEv',
        title: 'Assign EV',
        description: 'EV operator kiosk settings management',
        icon: Settings,
      },
      {
        path: '/AssignKiosk',
        title: 'Assign Kiosk',
        description: 'Assign a kiosk machine to a location',
        icon: Cpu,
      },
      {
        path: '/kiosk-flow-management',
        title: 'Kiosk Flow Management',
        description: 'Build and manage kiosk flows per operator',
        icon: Workflow,
      },
    ],
  },
  {
    title: 'Development & Testing Tools',
    items: [
      {
        path: '/device-customizer/kiosk',
        title: 'Kiosk Customizer',
        description: 'Customize kiosk UI appearance and design',
        icon: Palette,
      },
      {
        path: '/kiosk-preview-demo',
        title: 'Kiosk Preview Demo',
        description: 'Preview kiosk display in demo mode',
        icon: Monitor,
      },
      {
        path: '/popup-playground',
        title: 'Popup Playground',
        description: 'Test popup window functionality',
        icon: ExternalLink,
      },
    ],
  },
];
